import { FC } from 'react';
import { SelectProps } from 'antd';

import { useCases } from '@/features/vfo/hooks/useCases';
import { Select as SelectAntd } from '@/features/vfo/uikit/Select';

export const SelectVfoCase: FC<SelectProps> = ({ placeholder, ...props }) => {
  const { cases } = useCases();

  const options = cases.map((item) => ({
    value: item.id,
    label: item.title,
  }));

  return <SelectAntd placeholder={placeholder} options={options} {...props} />;
};
